// Amélioration du chargement des vidéos sur mobile
document.addEventListener('DOMContentLoaded', function() {
  // Améliorer le chargement des vidéos sur mobile
  if (window.innerWidth <= 749) {
    const videos = document.querySelectorAll('iframe[src*="youtube"], iframe[src*="youtu.be"]');
    
    // Observer pour charger les vidéos quand elles entrent dans le viewport
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const iframe = entry.target;
          
          // Forcer le chargement de la vidéo
          if (iframe.dataset.src) {
            iframe.src = iframe.dataset.src;
            iframe.removeAttribute('data-src');
          }
          
          // Ajouter des attributs pour améliorer le chargement
          iframe.setAttribute('loading', 'auto');
          iframe.style.willChange = 'transform';
          iframe.style.transform = 'translateZ(0)';
          
          videoObserver.unobserve(iframe);
        }
      });
    }, {
      rootMargin: '300px 0px' // Charger 300px avant d'entrer dans le viewport
    });
    
    videos.forEach((video, index) => {
      videoObserver.observe(video);
    });
  }
});

// Réinitialiser après le chargement des sections
document.addEventListener('shopify:section:load', function(event) {
  if (window.innerWidth <= 749) {
    setTimeout(() => {
      const videos = event.target.querySelectorAll('iframe[src*="youtube"], iframe[src*="youtu.be"]');
      videos.forEach(video => {
        video.setAttribute('loading', 'auto');
        video.style.willChange = 'transform';
        video.style.transform = 'translateZ(0)';
      });
    }, 100);
  }
});
